import React, { useEffect, useState } from 'react';
import orn from './../../../assets/images/ornament.svg';
import { Col, Row } from 'react-bootstrap';
import PostCard from './PostCard';
import axios from 'axios';

function Posts() {
    let [posts, setPosts] = useState([])
    useEffect(() => {
        axios.get('/siteposts')
            .then(res => {
                setPosts(res.data)
            })
    }, [])
    return (
        <>
            <div className="page-intro" style={{
                backgroundImage: 'url(' + orn + ')',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover'
            }}>
                <h1>Maqolalar</h1>
            </div>
            <Row className='mt-4' style={{ gap: '20px' }}>
                {
                    posts.map(p => (
                        <Col key={p.id} md={3}>
                            <PostCard post={p} />
                        </Col>

                    ))
                }
            </Row>

        </>
    );
}

export default Posts;